import {NewtimeDropdownService} from './../../_services/newtime-dropdown.service';
import { NewtimepickerComponent } from './newtimepicker.component';
import { NewtimeDropdownComponent } from './newtime-dropdown/newtime-dropdown.component';
import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';

import { NewtimepickerRoutingModule } from './newtimepicker-routing.module';
import { SharedModule } from '../../_module/shared.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [NewtimepickerComponent,NewtimeDropdownComponent],
  imports: [
    CommonModule,
    NewtimepickerRoutingModule,
    SharedModule,
    FormsModule,
  ],
  providers: [
    NewtimeDropdownService
  ],
  exports: [
    NewtimepickerComponent, NewtimeDropdownComponent
  ]
})
export class NewtimepickerModule { }
